import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { File, Eye, Download, Trash2 } from 'lucide-react';
import { formatFileSize } from '@/utils/fileUtils';

const ResourceFileCard = ({ file, onView, onDownload, onDelete, icon: Icon, iconBgColor, iconColor }) => {

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader className="pb-3">
        <div className="flex items-start gap-3">
          <div className={`p-2 ${iconBgColor} rounded-lg flex-shrink-0`}>
            {Icon ? (
              <Icon className={`w-4 h-4 ${iconColor}`} />
            ) : (
              <File className={`w-4 h-4 ${iconColor}`} />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <CardTitle className="text-sm font-semibold text-gray-900 mb-1">
              {file.name}
            </CardTitle>
            <p className="text-xs text-gray-500">
              {formatFileSize(file.size)}
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => onView(file)}
            className="flex items-center gap-1 flex-1"
          >
            <Eye className="w-3 h-3" />
            View
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => onDownload(file)}
            className="flex items-center gap-1 flex-1"
          >
            <Download className="w-3 h-3" />
            Download
          </Button>
          <Button
            size="sm"
            variant="destructive"
            onClick={() => onDelete(file)}
            className="flex items-center gap-1"
          >
            <Trash2 className="w-3 h-3" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ResourceFileCard;

